// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5321d8ee","952":"78141b59"}[chunkId] + ".chunk.js";
};